import { AuditCard } from "@/features/Audit/AuditCard";
import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";
import i18n from "@/i18n";
import { Button, Link } from "@heroui/react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { StrategiesEditCard } from "./edit_card";
import { Tables } from "@/gen/tableNames/tables";
import { Clients } from "@/lib/clients";
import { ClientTables } from "@/lib/clientTables";

export const StrategiesCard = () => {
  const { id } = useParams<{ id: string }>();
  const parsedId = Number(id);
  const isValidId = Number.isFinite(parsedId) && parsedId > 0;
  const [displayPortfoliLinksButton, setDisplayPortfoliLinksButton] =
    useState(false);

  if (!id || !isValidId) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="bg-gray-50 relative">
      <div className="flex flex-col gap-10 p-10">
        <div className="flex">
          <div className="flex-grow flex justify-center">
            <StrategiesEditCard
              id={parsedId}
              client={Clients.QTL}
              table_name={ClientTables.QTL_STRATEGIES}
              setDisplayPortfoliLinksButton={setDisplayPortfoliLinksButton}
            />
          </div>
          <div className="flex flex-col gap-2">
            <Button
              href={toWorkspacePath(
                `/admin/qtl%20-%20dynamic%20data/strategy_time_series?owner_id_equals=${id}&owner_type_contains=Strategy`,
              )}
              variant="bordered"
              color="primary"
              showAnchorIcon
              as={Link}
              radius="full"
              className="bg-white border-1 border-neutral-300 shadow-xl"
            >
              Time Series
            </Button>
            {displayPortfoliLinksButton && (
              <Button
                href={toWorkspacePath(
                  `/admin/qtl%20-%20dynamic%20data/links?strategy_from_id_equals=${id}`,
                )}
                variant="bordered"
                color="primary"
                showAnchorIcon
                as={Link}
                radius="full"
                className="bg-white border-1 border-neutral-300 shadow-xl"
              >
                Portfolio links
              </Button>
            )}
          </div>
        </div>

        <AuditCard
          id={parsedId}
          client={Clients.QTL}
          audit_table_name={Tables.STRATEGIES}
        />
      </div>
    </div>
  );
};
